import React, { useEffect, useState } from "react"
import {
  Button,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { EditableList } from "../../../compnents/list/EditableList"
import { RecordsTJXMColumns } from "../columns"
import axios from "axios"
import { useHistory } from "react-router-dom"
import { AXIOS_IP, FillingType } from "../fileUploadService"
import { TJXMFormModal } from "./TJXMFormModal"

export const RecordsTJXMModal = (props: {
  visible: boolean
  token: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [id, setId] = useState<any>()

  const [memo, setMemo] = useState<any>()

  const history = useHistory()

  const [pageLoading, setPageLoading] = useState(false)

  const [TJXMFormVisible, setTJXMFormVisible] = useState(false)

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    pageNo: 1,
    pageSize: 10,
  })

  const getData = () => {
    setPageLoading(true)
    axios({
      url: `${AXIOS_IP}/filingReviewCheckup/list`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
      data: { ...params },
    }).then((res) => {
      setPage({
        ...page,
        items: res.data.data?.list || [],
        total: res.data.data?.total || 0,
      })
      setPageLoading(false)
    })
  }

  useEffect(() => {
    if (!props.visible) return
    getData()
  }, [props.visible, params])

  return (
    <>
      <Modal
        title="体检项目备案申请记录"
        width={1200}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        footer={null}
        centered
        maskClosable={false}
      >
        <div>
          <EditableList
            style={{ flex: 1, height: "450px" }}
            scroll={{ x: "30rem" }}
            page={{
              items: page.items,
              current: params.pageNo,
              size: params.pageSize,
              total: page.total,
            }}
            pageSizeOptions={["10", "20", "50", "100"]}
            loading={pageLoading}
            rowKey={(m: any) => m.id}
            columns={RecordsTJXMColumns(
              params.pageSize * (params.pageNo - 1),
              (action: any, t: any) => {
                switch (action) {
                  case "detail":
                    history.push({
                      pathname: "/filingManagementDetail",
                      state: {
                        id: t.id,
                        state: 2,
                        fileData: t.reportFile,
                        type: FillingType.TJXM,
                      },
                    })
                    break
                  case "filing": 
                    setId(t.id)
                    setMemo(t.memo)
                    setTJXMFormVisible(true)
                    break
                }
              }
            )}
            onChangePage={(current, size) =>
              setParams({ ...params, pageNo: current, pageSize: size || 10 })
            }
            sticky
          />
        </div>
      </Modal>

      <TJXMFormModal
        visible={TJXMFormVisible}
        token={props.token}
        id={id}
        memo={memo}
        onOk={() => {
          setTJXMFormVisible(false)
          getData()
        }}
        onCancel={() => setTJXMFormVisible(false)}
      />
    </>
  )
}
